import { PagePolicy } from '@/policies';
import { auth } from '@/services';

angular.module('app')
    .controller('managePageController', managePageController);

managePageController.$inject = [
    '$scope',
    '$rootScope',
    '$uibModalInstance',
    'pageId',
    'PagesApi',
    'handleError',
    '$timeout',
    'confirmDialog',
    'UploadsApi',
];

function managePageController(
    $scope,
    $rootScope,
    $uibModalInstance,
    pageId,
    PagesApi,
    handleError,
    $timeout,
    confirmDialog,
    UploadsApi
) {
    // properties
    $scope.isLoading = false;
    $scope.isLoadingMessage = 'Loading...';
    $scope.pageId = pageId;
    $scope.createNewPage = !pageId;
    $scope.faqPage = false;
    $scope.thisUser = $rootScope.thisUser;
    $scope.formErrors = {};
    $scope.imageFile = null;
    $scope.imageFileLogo = null;
    $scope.page = {
        body: '<p><br></p>',
        settings: {},
        status: 'approved',
    };
    $scope.coverImageUploadOptions = {
        resize: true,
        resizeSize: {
            w: 1920,
            h: 600,
        },
        resizeShape: 'rectangle',
        resizeAspectRatio: 0,
    };
    $scope.permissionChecks = {
        canDelete: PagePolicy.canDelete(auth.user()),
        canManage: PagePolicy.canManage(auth.user()),
    };

    // methods
    $scope.close = $uibModalInstance.close;
    $scope.handleBodyChange = handleBodyChange;
    $scope.handleImage = handleImage;
    $scope.savePage = savePage;
    $scope.deletePage = deletePage;
    $scope.handleImageError = handleImageError;

    $scope.handleImageLogo = handleImageLogo;
    $scope.handleImageLogoError = handleImageLogoError;

    $scope.logoImageUploadOptions = {
        resize: true,
        resizeSize: {
            w: 1920,
            h: 600,
        },
        resizeShape: 'rectangle',
        resizeAspectRatio: 0,
    };

    // Initialize newQuestion in the controller
    $scope.newQuestion = '';

    $scope.addQuestion = function (newQuestionValue) {

        $scope.newQuestion = newQuestionValue;
        // Check if newQuestion is not empty and is a string
        if ($scope.newQuestion && typeof $scope.newQuestion === 'string') {


            // Check if faq_default_questions exists and is an array
            if (!$scope.page.faq_settings.faq_default_questions.value) {
                $scope.page.faq_settings.faq_default_questions.value = [];
            }

            // Add the new question to the array
            $scope.page.faq_settings.faq_default_questions.value.push($scope.newQuestion);

            // Clear the input field
            $scope.newQuestion = '';
        }
    };

    $scope.removeQuestion = function(index) {
        if (Array.isArray($scope.page.faq_settings.faq_default_questions.value)) {
            // Remove the question from the array by index
            $scope.page.faq_settings.faq_default_questions.value.splice(index, 1);
        }
    };


    // Do we need to load a page?
    if (!$scope.createNewPage) {
        getPage();
    }

    /**
     * Loads a page to be edited
     * @return {void}
     */
    function getPage() {
        $scope.isLoadingMessage = 'Loading page...';
        $scope.isLoading = true;

        PagesApi.get({
            id: $scope.pageId,
        }, response => {
            // Check if response.data contains the necessary fields
            if (response.data && response.data.slug) {
                $scope.page = response.data;
                $scope.faqPage = response.data.slug === 'faq';

                if ($scope.faqPage) {
                    $scope.page.faq_settings = response.faq_settings || {};
                }
            } else {
                console.error('Invalid response structure:', response);
            }

            $scope.isLoading = false;
        }, err => {
            $scope.isLoading = false;
            handleError(err);
        });
    }


    /**
     * Updates body content.
     *
     * @param {string} content html
     * @returns {void}
     */
    function handleBodyChange(content) {
        $scope.page.body = content;
    }

    /**
     * Handles the image chosen by the user
     * @param  {file} file - Provided by ngFileUpload plugin
     * @return {void}
     */
    function handleImage(file) {
        $scope.imageFile = file;
    }

    /**
     * Handles the image chosen by the user
     * @param  {file} file - Provided by ngFileUpload plugin
     * @return {void}
     */
    function handleImageLogo(file) {
        $scope.imageFileLogo = file;
    }

    /**
     * Shows file errors
     * @param  {object} imageError - provide as  {image: '[message]'}
     * @return {void}
     */
    function handleImageError(imageError) {
        $scope.formErrors = angular.merge($scope.formError, imageError);
    }

    /**
     * Shows file errors
     * @param  {object} imageError - provide as  {image: '[message]'}
     * @return {void}
     */
    function handleImageLogoError(imageError) {
        $scope.formErrors = angular.merge($scope.formError, imageError);
    }


    /**
     * Attempts to create a new page from the provided form data
     * @return {void}
     */
    function savePage() {
        // Initialize upload promises array
        let uploadPromises = [];

        // Check and add image file upload promise
        if ($scope.imageFile) {
            uploadPromises.push(
                UploadsApi.uploadImage($scope.imageFile, 'site')
                    .then(img => {
                        if (img && img.path) {
                            $scope.page.img = img.path;
                        }
                    }),
            );
        }

        // Check and add logo file upload promise
        if ($scope.imageFileLogo) {
            uploadPromises.push(
                UploadsApi.uploadImage($scope.imageFileLogo, 'site')
                    .then(imgLogo => {
                        if (imgLogo && imgLogo.path) {
                            $scope.page.faq_settings.faq_logo.value = imgLogo.path;
                        }
                    }),
            );
        }

        // Handle all upload promises
        Promise.all(uploadPromises).then(() => {
            let funcName;
            let params;

            if ($scope.createNewPage) {
                funcName = 'save';
                params = {
                    id: $scope.pageId,
                    type: 'page',
                };
            } else {
                funcName = 'update';
                params = {};
            }

            $scope.isLoadingMessage = ($scope.createNewPage ? 'Creating new page...' : 'Saving page...');
            $scope.isLoading = true;

            PagesApi[funcName](params, $scope.page, response => {
                // Wait for UI prettiness
                $timeout(() => {
                    $scope.isLoading = false;

                    // Close modal
                    $uibModalInstance.close(response.data);
                }, 400);
            }, err => {
                $scope.isLoading = false;
                $scope.formErrors = err.data;
            });
        }).catch(err => {
            // Handle upload errors
            $scope.isLoading = false;
            console.error('Upload failed:', err);
            $scope.formErrors = err.data;
        });
    }


  /**
     * Deletes this page after the user confirms
     * @return {void}
     */
    function deletePage() {
        confirmDialog('Are you sure you want to delete this page?')
            .result.then(confirm => {
                if (confirm) {
                    $scope.isLoadingMessage = 'Deleting...';
                    $scope.isLoading = true;

                    PagesApi.delete({
                        id: $scope.page.id,
                    }, function handleDeletePageResponse() {
                        $scope.forceClose = true;
                        $uibModalInstance.dismiss('deleted');
                    }, function handleDeletePageError() {
                        $scope.isLoading = false;
                    });
                }
            });
    }

    // Catch the modal being closed for any reason
    $scope.$on('modal.closing', (event, reason, closed) => {
        if ($scope.forceClose) {
            return true;
        }

        if (!closed) {
            return event.preventDefault();
        }

        if (Object.keys($scope.page).length > 4) {
            event.preventDefault();

            // Todo: replace browser confirm with custom
            confirmDialog('Are you sure?').result.then(confirm => {
                if (confirm) {
                    $scope.forceClose = true;
                    $uibModalInstance.close(reason);
                }
            });
        }
    });
}
